import { GlobalStatus, JobTypesEnum } from "@gtpl/shared-models/common-models";
import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToOne } from "typeorm";
import { SaleOrder } from "./sale-order.entitiy";

@Entity('so_invoice_details')
export class SoInvoiceDetails {

  @PrimaryGeneratedColumn("increment", { name: 'inv_details_id' })
  invDetailsId: number;

  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "po_number"
  })
  poNumber: string;

  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "buyer_po_number"
  })
  buyerPoNumber: string;
  
  @Column("datetime", {
    nullable: true,
    name: "stock_reported_date"
  })
  stockreportedDate: Date;
  @Column("int", {
    nullable: true,
    name: "reserved_per"
  })
  reservedPer: number;
  @Column("date", {
    nullable: true,
    name: "invoice_date"
  })
  invoiceDate: Date;

  @Column("date", {
    nullable: true,
    name: "eda_date"
  })
  edaDate: Date;

  @Column("date", {
    nullable: true,
    name: "act_edl_date"
  })
  actualEdldate: Date;

  @Column("date", {
    nullable: true,
    name: "edl_date"
  })
  edlDate: Date;

  @Column("varchar", {
    nullable: false,
    length: 255,
    name: "cus_address"
  })
  cusAddress: string;

  @Column("varchar", {
    nullable: false,
    length: 250,
    name: "del_address"
    //delivery address
  })
  delAddress: string;

  @Column("int", {
    nullable: false,
    name: "del_terms"
  })
  deliveryTerms: number;

  @Column("int", {
    nullable: false,
    name: "end_customer_id"
  })
  endCustomerId: number;

  @Column("int", {
    nullable: false,
    name: "customer_id"
  })
  customerId: number;

  @Column("int", {
    nullable: false,
    name: "country_id"
  })
  country: number;

  @Column("int", {
    nullable: false,
    name: "destination"
  })
  destination: number;

  @Column("int", {
    nullable: true,
    name: "port_of_entry"
  })
  portOfEntry: number;

  @Column("int", {
    nullable: false,
    name: "pay_terms_id"
  })
  payTermId: number;

  @Column("int", {
    nullable: false,
    name: "shipment_terms"
  })
  shipmentTerms: number;

  @Column("int", {
    nullable: false,
    name: "emp_id"
  })
  salePersonId: number;

  @Column("int", {
    nullable: true,
    name: "currency_id"
  })
  currency: number;
  @Column("int", {
    nullable: true,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column("int", {
    nullable: true,
    name: "factoryId"
  })
  unit: number;
  @Column({
    type: 'enum',
    nullable: false,
    enum: JobTypesEnum,
    default: JobTypesEnum.MAIN_JOB,
    name: "job_type"
  })
  jobType: JobTypesEnum;
  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_sub_contract"
  })
  isSubContract: GlobalStatus;
  @Column("int", {
    nullable: true,
    name: "processing_unit"
  })
  processingUnit: number;
  //need to remove category column
  @Column("varchar", {
    length:20,
    nullable: true,
    name: "category"
  })
  category: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
	default:"Admin",
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

    @OneToOne(type=>SaleOrder, saleOrder=>saleOrder.SoInvDetailsInfo,{  nullable:false })
    @JoinColumn({ name:"sale_order_id"})
    saleOrderInfo: SaleOrder;

}
